import { apiClient } from "../../services/apiService";
import Logger from "../../utils/logger";

// Send deployment data to Jenkins
export const sendDeploymentToJenkins = async (
  repoName: string,
  envName: string,
  branchName: string
) => {
  try {
    Logger.info("Attempting to send deployment data to Jenkins", {
      repoName,
      envName,
      branchName,
    });
    const { data } = await apiClient.post("jenkins/deployment-request", {
      parameters: {
        repoName,
        envName,
        branchName,
      },
    });
    return data;
  } catch (error) {
    Logger.error("Failed to send deployment data to Jenkins", { error });
    throw error;
  }
};
